/**
 * Portfolio ID configuration for Illio API integration
 *
 * These are test portfolio IDs that exist in the Illio system for development
 * and testing purposes. The frontend determines which portfolio to use based
 * on the current organization context.
 */

export const TEST_PORTFOLIO_IDS = {
  'Wise Capital Production': '91c508b6-5fb8-48c1-8390-2a2d550973a8',
  'Wise Capital Demo': '00998f4b-d3a3-4a19-9abd-9d3302db2dd5',
} as const;

/**
 * Get the appropriate test portfolio ID for the given organization
 * @param organizationName - The name of the organization
 * @returns The portfolio ID for the organization, or the production ID as fallback
 */
export const getPortfolioIdForOrganizationTestingHardcoded = (
  organizationName: string
): string => {
  return (
    TEST_PORTFOLIO_IDS[organizationName as keyof typeof TEST_PORTFOLIO_IDS] ||
    TEST_PORTFOLIO_IDS['Wise Capital Production']
  );
};
